import React, { useState, useEffect } from "react";
import '../App.css';
import Output from './output';

function AddData() {
  // Function to retrieve tasks from localStorage
  const Store = () => {
    const savedTasks = localStorage.getItem('tasks');
    return savedTasks ? JSON.parse(savedTasks) : [];
  };

  const [newIteam, setnewIteam] = useState('');
  const [tasks, setTasks] = useState(Store);

  // Handle task submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setTasks([...tasks, newIteam]);  // Add new task to the list
    setnewIteam('');  // Clear input after submission
  }

  // Delete task
  const deleteTask = (index) => {
    const updatedTasks = [...tasks]; 
    updatedTasks.splice(index, 1);  // Remove task at specified index
    setTasks(updatedTasks);  // Update state with the new task list
  };

  // Save tasks to localStorage whenever the tasks list changes
  useEffect(() => {
    localStorage.setItem('tasks', JSON.stringify(tasks));  
  }, [tasks]);

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <label htmlFor="task">Task:</label>
        <br />
        <input 
          type="text" 
          id="task" 
          name="task" 
          placeholder="Enter task" 
          value={newIteam} 
          onChange={e => setnewIteam(e.target.value)} 
          required 
        />
        <input type="submit" className="submit-btn" value="Add Task" />
        
        <hr />
        <Output tasks={tasks} deleteTask={deleteTask} />
      </form>
    </div>
  );
}

export default AddData;
